import { LinkTo } from '@ember/routing';
import { or } from 'tio-ui/utilities';
import { t } from 'ember-intl';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import TuitionAssistanceCardsGeneric from './cards/generic.gts';
import type { TOC } from '@ember/component/template-only';
import Chip from 'tio-ui/components/chip';
import { on } from '@ember/modifier';
import Button from 'tio-ui/components/button';
import { PhCheckCircle } from 'ember-phosphor-icons';

// TODO: is this component overly used. There are places where the consumer passes no args.
export interface Pill {
  label: string;
  intent: 'default' | 'primary' | 'success' | 'warning' | 'danger' | undefined;
}

export interface TAProgramCardSignature {
  Args: {
    buttonClass?: string;
    buttonLoading?: boolean;
    buttonRoute?: string;
    buttonRouteModel?: unknown;
    buttonText?: string;
    disableButton?: boolean;
    id?: string;
    instanceIdForExistingApp?: string;
    isMultipleInstanceProgram?: boolean;
    isComplete?: boolean;
    onClick?: () => void;
    pills?: Pill[];
    showDashboardProgramMessagesIcon?: boolean;
    showMessagesLink?: boolean;
    title?: string;
    titleClass?: string;
    useTextLinkTo?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const TuitionAssistanceProgramCard: TOC<TAProgramCardSignature> = <template>
  <TuitionAssistanceCardsGeneric ...attributes>
    <:headerTitle>
      {{#if @title}}
        <div class={{@titleClass}}>
          {{@title}}
        </div>
        {{#if @id}}
          <div class="tio-text-sm-normal tio-fg-secondary">
            {{t "tuition_assistance.id"}}{{@id}}
          </div>
        {{/if}}
      {{/if}}

      {{#each @pills as |pill|}}
        <Chip @size="sm" @intent={{pill.intent}}>
          {{pill.label}}
        </Chip>
      {{/each}}
    </:headerTitle>
    <:headerRight>
      {{#if @isComplete}}
        <PhCheckCircle @size="24" class="tio-fg-success" />
      {{/if}}
    </:headerRight>
    <:body>
      {{yield}}
    </:body>
    <:footer>
      {{#if (or @buttonRoute @onClick)}}
        <div class="tio-row-center mt-4 mb-2">
          {{#if @useTextLinkTo}}
            <LinkTo
              @route={{@buttonRoute}}
              @model={{@buttonRouteModel}}
              class="tio-copy !font-normal"
            >
              {{@buttonText}}
            </LinkTo>
          {{else}}
            <Button
              class="{{if @buttonClass @buttonClass 'w-72'}}"
              {{on "click" (transitionTo @buttonRoute @buttonRouteModel)}}
              @isRunning={{@buttonLoading}}
              disabled={{@disableButton}}
              data-test="{{@buttonRouteModel}}"
              @intent="primary"
            >
              {{@buttonText}}
            </Button>
          {{/if}}
        </div>
      {{/if}}
      {{#if @instanceIdForExistingApp}}
        <div class="tio-flex-center text-sm">
          <span class="text-center">
            {{t "tuition_assistance.you_already_have_an_active_program"}}
            {{#if @isMultipleInstanceProgram}}
              <LinkTo @route="authenticated.tuition-assistance.dashboard" class="tio-copy">
                {{t "click_here"}}
              </LinkTo>
            {{else}}
              <LinkTo
                @route="authenticated.tuition-assistance.programs.instance.index"
                @model={{@instanceIdForExistingApp}}
                class="tio-copy"
              >
                {{t "click_here"}}
              </LinkTo>
            {{/if}}
            {{t "tuition_assistance.to_view_program_details"}}
          </span>
        </div>
      {{/if}}
    </:footer>
  </TuitionAssistanceCardsGeneric>
</template>;

export default TuitionAssistanceProgramCard;
